import React, {useEffect, useRef, useState} from "react";
import {useInView} from "react-intersection-observer";

export default function Title({title, id}: { title: string, id?: string }) {
    const divRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (divRef.current == null) {
            return;
        }

        const handleResize = () => {
            const div = divRef.current as unknown as HTMLDivElement;
            const child = div.children[0] as unknown as HTMLDivElement;
            const span = child.children[0] as unknown as HTMLSpanElement;

            const sinAlpha = 0.9961946981;
            const sinBeta = 0.08715574275;
            const a = div.offsetWidth;
            const b = (a * sinBeta) / sinAlpha;
            const spanHeight = span.offsetHeight + b;

            setHeight((spanHeight - child.offsetHeight) / 2);
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div id={id} className="relative flex px-3"
             style={{paddingTop: height + "px", paddingBottom: height + "px"}}>
            <div ref={divRef} className="min-w-[16rem] min-h-[4rem] py-2">
                <div className="bg-accent w-fit px-2 py-0.5 rotate-title">
                    <span className="text-center text-light font-semibold text-5xl tracking-wide uppercase">
                        {title}
                    </span>
                </div>
            </div>
        </div>
    );
}
